module.exports = __webpack_public_path__ + "static/cloud-cost-management-hero.5ee32991.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cloud-cost-management-hero.png
// module id = 63
// module chunks = 35783957827783 159014900043430 207353970745078